module.exports = __webpack_public_path__ + "static/media/asesor_icon.41b02a34.svg";